var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.172,
    height: 28.074,
    viewBox: "0 0 73.172 28.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e72e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#d82a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b22162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#871759"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "small_logo",
    "data-name": "small logo",
    transform: "translate(-17.33 -12.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 13.03,
    height: 3.145,
    rx: 1.573,
    transform: "translate(77.472 12.468)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 7.638,
    height: 3.145,
    rx: 1.573,
    transform: "translate(77.472 20.556)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 13.03,
    height: 3.145,
    rx: 1.573,
    transform: "translate(77.472 28.195)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M42.946,14.08a3.752,3.752,0,0,1-.216,1.02L38.107,30.125a1.835,1.835,0,0,1-1.91,1.343,1.875,1.875,0,0,1-1.91-1.343L30.149,18.834,25.984,30.125A1.844,1.844,0,0,1,24.1,31.469a1.886,1.886,0,0,1-1.937-1.343L17.573,15.1a3.008,3.008,0,0,1-.243-1.02A1.717,1.717,0,0,1,19.1,12.44a1.744,1.744,0,0,1,1.721,1.155l3.415,12.123,4.3-12.1a1.581,1.581,0,0,1,1.586-1.182,1.64,1.64,0,0,1,1.64,1.182l4.3,12.1,3.388-12.123A1.75,1.75,0,0,1,41.2,12.44a1.692,1.692,0,0,1,1.748,1.64Z",
    transform: "translate(0 -0.066)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M88.422,29.773a1.7,1.7,0,0,1-1.721,1.64,1.845,1.845,0,0,1-1.775-1.155l-1.37-3.2h-7.58l-1.37,3.2a1.8,1.8,0,0,1-1.748,1.155,1.707,1.707,0,0,1-1.748-1.64,2.453,2.453,0,0,1,.243-1.02l6.668-15.079a1.821,1.821,0,0,1,1.748-1.343,1.874,1.874,0,0,1,1.775,1.343l6.668,15.079a2.478,2.478,0,0,1,.216,1.02Zm-6.075-5.59-2.579-6.075-2.579,6.075h5.163Z",
    transform: "translate(-29.615 -0.006)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M123.707,13.96a2.447,2.447,0,0,1-.216,1.02l-6.668,15.079a1.874,1.874,0,0,1-1.775,1.343,1.821,1.821,0,0,1-1.748-1.343L106.633,14.98a2.488,2.488,0,0,1-.243-1.02,1.71,1.71,0,0,1,1.748-1.64,1.808,1.808,0,0,1,1.748,1.155l5.163,12.15,5.163-12.15a1.834,1.834,0,0,1,1.775-1.155,1.7,1.7,0,0,1,1.721,1.64Z",
    transform: "translate(-49.043)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(38.803 35.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M68.162,66.26c0,.836-.616,1.384-1.6,1.384h-.908v1.411a.272.272,0,0,1-.265.27.276.276,0,0,1-.27-.27V65.178a.276.276,0,0,1,.288-.288h1.15a1.419,1.419,0,0,1,1.6,1.37Zm-.521,0c0-.593-.422-.908-1.087-.908h-.894v1.824h.894c.665,0,1.087-.288,1.087-.921Z",
    transform: "translate(-65.12 -64.845)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M86.126,69.074a.236.236,0,0,1-.238.247.26.26,0,0,1-.2-.1l-1.245-1.568h-.876v1.411a.272.272,0,0,1-.265.27.276.276,0,0,1-.27-.27V65.188a.276.276,0,0,1,.288-.288h1.15a1.419,1.419,0,0,1,1.6,1.37,1.314,1.314,0,0,1-1.078,1.33l1.069,1.3a.308.308,0,0,1,.063.175Zm-2.561-1.887h.894c.665,0,1.087-.288,1.087-.921,0-.593-.422-.908-1.087-.908h-.894v1.824Z",
    transform: "translate(-74.983 -64.851)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M103.946,67.037a2.189,2.189,0,1,1-2.184-2.247A2.223,2.223,0,0,1,103.946,67.037Zm-3.819,0a1.637,1.637,0,1,0,1.636-1.743A1.679,1.679,0,0,0,100.127,67.037Z",
    transform: "translate(-84.091 -64.79)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M122.12,65.106v2.53c0,1.258-.687,1.68-1.447,1.68a1.516,1.516,0,0,1-1-.328.375.375,0,0,1-.171-.283.219.219,0,0,1,.225-.234.317.317,0,0,1,.207.076,1.085,1.085,0,0,0,.737.279c.49,0,.9-.261.9-1.191v-2.53a.27.27,0,0,1,.279-.256.265.265,0,0,1,.27.256Z",
    transform: "translate(-95.066 -64.823)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M139.826,68.822a.236.236,0,0,1,.238.234.24.24,0,0,1-.238.238h-2.318a.276.276,0,0,1-.288-.288V65.178a.276.276,0,0,1,.288-.288h2.251a.242.242,0,0,1,.238.234.237.237,0,0,1-.238.238H137.75v1.492h1.415a.236.236,0,0,1,.234.225.23.23,0,0,1-.234.225H137.75v1.519h2.071Z",
    transform: "translate(-104.824 -64.845)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M157.962,68.624c0,.121-.076.216-.22.31a1.887,1.887,0,0,1-1.15.359,2.247,2.247,0,0,1,.013-4.493,1.924,1.924,0,0,1,1.141.35c.144.1.22.189.22.315a.236.236,0,0,1-.247.238.427.427,0,0,1-.265-.121,1.422,1.422,0,0,0-.858-.283,1.746,1.746,0,0,0,0,3.487,1.4,1.4,0,0,0,.863-.283.438.438,0,0,1,.265-.121.239.239,0,0,1,.247.238Z",
    transform: "translate(-114.279 -64.796)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M175.977,65.124a.237.237,0,0,1-.238.238h-1.083v3.68a.279.279,0,0,1-.265.283.282.282,0,0,1-.27-.283v-3.68h-1.087a.233.233,0,0,1-.234-.238.238.238,0,0,1,.234-.234h2.7A.242.242,0,0,1,175.977,65.124Z",
    transform: "translate(-124.417 -64.845)",
    fill: "#161d27"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLogo);
export default __webpack_public_path__ + "static/media/wave_logo.70a1031edc03f96fe75eca57db801ea8.svg";
export { ForwardRef as ReactComponent };